/**
 * Label for a dropdown option that pairs a master code with its description:
 * `CODE - Description`, or the bare `CODE` when there is no description to add.
 *
 * Stored values are always the bare code, so a dropdown's resting label may show
 * less than its open list does — the description is decoration, never the value.
 */
export function formatCodeLabel(code: string, description?: string | null): string {
    const trimmed = description?.trim();
    return trimmed ? `${code} - ${trimmed}` : code;
}
